var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"officebodyContent-mobile"},[_c('div',{staticClass:"mainContent"},[_c('mainpage')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }